import { useCallback } from 'react';
import { IconButton, List, ListItem, ListItemIcon, ListItemText, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import logo from 'assets/images/footer_logo.png';
import LabelImportantTwoToneIcon from '@mui/icons-material/LabelImportantTwoTone';
import { Instagram } from '@mui/icons-material';
import { INSTAGRAM_LINK } from './constants';
import { GoogleMap } from 'components/@shared/GoogleMap';
import { COMPANY_ADDRESS } from 'constants/general';
import { AdvancedMarker } from '@vis.gl/react-google-maps';

const mainStyles = {
    width: '100%',
    marginTop: 'auto',
    backgroundColor: 'secondary.main',
    padding: 2,
};

const listItemIconStyles = {
    minWidth: '30px',
};

const listItemStyles = {
    color: 'common.white',
};

export const HomeFooter = () => {
    const goToInstagram = useCallback(() => {
        window.open(INSTAGRAM_LINK, '_blank');
    }, []);

    return (
        <Box component="footer" sx={mainStyles}>
            <Grid container>
                <Grid item xs={12} md={6}>
                    <Box display="flex" gap={3} px={1}>
                        <Box component="img" src={logo} height={100} width={100} sx={{ alignSelf: 'center' }} />
                        <Box>
                            <Typography color="common.white">Licensed Electrical Contractor</Typography>
                            <Typography color="common.white" variant="subtitle2" fontStyle="italic" mb={1}>
                                License #18979
                            </Typography>
                            <List disablePadding>
                                <ListItem disablePadding>
                                    <ListItemIcon sx={listItemIconStyles}>
                                        <LabelImportantTwoToneIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText sx={listItemStyles}>Residential</ListItemText>
                                </ListItem>
                                <ListItem disablePadding>
                                    <ListItemIcon sx={listItemIconStyles}>
                                        <LabelImportantTwoToneIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText sx={listItemStyles}>Commercial</ListItemText>
                                </ListItem>
                                <ListItem disablePadding>
                                    <ListItemIcon sx={listItemIconStyles}>
                                        <LabelImportantTwoToneIcon color="primary" />
                                    </ListItemIcon>
                                    <ListItemText sx={listItemStyles}>Fully bonded & Insured</ListItemText>
                                </ListItem>
                            </List>
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box display="flex" gap={2} height={150}>
                        <Box display="flex" flexDirection="column" gap={1} justifyContent="space-between">
                            <Typography color="common.white" fontWeight={500}>
                                Contact Info
                            </Typography>
                            <Typography color="common.white" variant="subtitle2">
                                Call or Text: 908-670-8219
                            </Typography>
                            <Typography color="common.white" variant="subtitle2">
                                Email: contaldilititelectric@gmail.com
                            </Typography>
                            <Typography color="common.white" variant="subtitle2">
                                29 Washington St Keyport NJ 07735
                            </Typography>
                            <Box display="flex" gap={1} alignItems="center">
                                <Typography color="common.white" fontWeight={500}>
                                    Follow us:
                                </Typography>
                                <Stack gap={1}>
                                    <IconButton onClick={goToInstagram}>
                                        <Instagram color="primary" />
                                    </IconButton>
                                </Stack>
                            </Box>
                        </Box>
                        <Box height="100%" flex="1">
                            <GoogleMap mapId="company-address" center={COMPANY_ADDRESS}>
                                <AdvancedMarker position={COMPANY_ADDRESS} />
                            </GoogleMap>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};
